// src/services/qrApplicationInfo.service.ts
import { BASE_URL } from "../../../constants/Constants";

const QR_API_URL = `${BASE_URL}/api/qr-application-info`;
export interface QRApplicationInfoResponse {
    applicationId: string;
    plotOwner: string;
    applicationSubmissionDate: string;
    certificateApprovalDate: string;
    siteDetails: {
        siteAddress: string;
        plotNo: string;
        layout: string;
        mauza: string;
        khasaraNo: string;
        plotAreaAsPerSaleDeed: number;
        regularizedArea: number;
        builtUpArea: number;
        plotAreaSurrendered: number;
        areaToBeDemolished: number;
    };
}

export interface QRTimelineRow {
    stepNo: number;
    authorityOrApplicant: string;
    designation: string;
    applicationReceivedDate: string;
    applicationForwardedOrApprovedDate: string;
    applicationReturnedDate: string | null;
    documentsVerified: string;   // ✔ or NA
    technicalApproval: string;   // ✔ or NA
    applicationStatus: string;
}

class QRApplicationInfoService {

    /**
     * Fetch main QR application + certificate data
     */
    static async getApplicationInfo(applicationId: string): Promise<QRApplicationInfoResponse> {
        const response = await fetch(`${QR_API_URL}/${applicationId}`);

        if (!response.ok) {
            throw new Error("Failed to fetch application info");
        }

        const result = await response.json();

        if (!result.success || !result.data) {
            throw new Error("No application data found");
        }

        return result.data;
    }

    /**
     * Fetch proposal timeline data
     */
    static async getApplicationTimeline(applicationId: string): Promise<QRTimelineRow[]> {
        const response = await fetch(`${QR_API_URL}/${applicationId}/timeline`);

        if (!response.ok) {
            throw new Error("Failed to fetch timeline data");
        }

        const result = await response.json();

        if (!result.success || !result.data) {
            return [];
        }

        return result.data;
    }
}

export default QRApplicationInfoService;
